import { Injectable } from "@angular/core";

import { GrowthHabitSearchCriteria } from "@models/GrowthHabitSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class GrowthHabitSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<GrowthHabitSearchCriteria> {
    const criteria = await this.ps.getGrowthHabitSearchCriteria();
    return criteria;
  }
}
